import { Route } from '@angular/router';

import { blogIndexResolver, blogPostResolver } from './blog.resolver';

/**
 * The blog's two routes, mounted at `/blog` by the app.
 *
 * The resolvers are the load-bearing part. Prerendering waits for a
 * navigation, resolvers included, before it serialises the document, so a body
 * resolved here is in the HTML and a body fetched from `ngOnInit` might not
 * be.
 */
export const blogRoutes: Route[] = [
  {
    path: '',
    loadComponent: () =>
      import('./blog-index/blog-index.component').then(
        (m) => m.BlogIndexComponent
      ),
    resolve: { posts: blogIndexResolver },
  },
  {
    path: ':slug',
    loadComponent: () =>
      import('./blog-post/blog-post.component').then(
        (m) => m.BlogPostComponent
      ),
    resolve: { post: blogPostResolver },
  },
];
